import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@kop/ui/styles.css';
import './workspace.css';
import { WorkspaceApp } from './workspace-app';
import { RuntimeErrorBoundary } from './runtime/runtime-error-boundary';
import './runtime/runtime.css';
import { PwaStatus } from './runtime/pwa-status';
import { PwaProvider } from './runtime/pwa-context';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root element is missing.');
}

createRoot(root).render(
  <StrictMode>
    <RuntimeErrorBoundary>
      <PwaProvider>
        <WorkspaceApp />
        <PwaStatus />
      </PwaProvider>
    </RuntimeErrorBoundary>
  </StrictMode>,
);
